import { createSlice } from '@reduxjs/toolkit'

export const websiteSlice = createSlice({
  name: 'website',
  initialState: {
    url: 'https://teknikforce.com/'
  },
  reducers: {
    setWebsiteField(state, action) {
      state.url = action.payload
    },
    initializeWebsite(state, action) {
      state.url = 'https://teknikforce.com/'
    }
  }
})

export const {
  setWebsiteField,
  initializeWebsite
} = websiteSlice.actions
export default websiteSlice.reducer